import type { Env, EnvHost } from './types';

/**
 * List of possible hosts to use with the application urls.
 * This is usually used as the app host. When using localhost
 * you might need to append the port.
 */
export const envHost: Record<Env, EnvHost> = {
  local: 'local.fff-dev',
  dev: 'fff-dev',
  qa: 'qa.fff-dev',
  prod: 'fabfitfun',
  load01: 'fff-load01',
  load02: 'fff-load02',
};

/**
 * Retrieves the environment host for the application.
 */
export const getEnvHost = (env: Env) => `${envHost[env]}.com`;

/**
 * List of possible hosts to use with the APIs urls. Localhost
 * will match dev environment as we don't have a defined
 * process to run the APIs locally.
 */
export const apiEnvHost: Record<Env, EnvHost> = {
  local: 'fff-dev',
  dev: 'fff-dev',
  qa: 'fff-dev',
  prod: 'fabfitfun',
  load01: 'fff-load01',
  load02: 'fff-load02',
};

/**
 * Retrieves the environment host for the APIs.
 */
export const getApiEnvHost = (env: Env) => `${apiEnvHost[env]}.com`;

/**
 * List of possible hosts to use with the APIs urls. Localhost
 * will match dev environment as we don't have a defined
 * process to run the APIs locally.
 */
export const contentEnvHost: Record<Env, EnvHost> = {
  local: 'fff-dev',
  dev: 'fff-dev',
  qa: 'fff-qa',
  prod: 'fabfitfun',
  load01: 'fff-load01',
  load02: 'fff-load02',
};

/**
 * Retrieves the environment host for the APIs.
 */
export const getContentEnvHost = (env: Env) => `${contentEnvHost[env]}.com`;
